import { axios } from 'configs'
import type {
  TCreateOrganizationRequest,
  TOrganization,
  TUpdateOrganizationRequest,
} from 'types'

export const listOrganizations = async (): Promise<TOrganization[]> => {
  const response = await axios.get<TOrganization[]>('/admin/organizations')
  return response.data
}

export const createOrganization = async (
  request: TCreateOrganizationRequest,
): Promise<TOrganization> => {
  const response = await axios.post<TOrganization>('/admin/organizations', request)
  return response.data
}

export const updateOrganization = async (
  organizationId: number,
  request: TUpdateOrganizationRequest,
): Promise<TOrganization> => {
  const response = await axios.put<TOrganization>(
    `/admin/organizations/${organizationId}`,
    request,
  )
  return response.data
}
